import React from 'react';
import Modal from 'react-responsive-modal';

import PlacesSearch from '../home/PlacesSearch';

const LocationModal = ({ open, hideModal, title }) => {
	return (
		<Modal open={open} onClose={() => hideModal()}>
			<div className="update-location-modal">
				<h6>{title ? title : 'Update Your Location - Required'}</h6>
				<div className="place-selection">
					<PlacesSearch />
				</div>

				<div className="alert alert-primary mt-3" role="alert">
					Location is required because prices, taxes, product availability, and the type of service are
					dependent on where you are located. If you have any questions please contact us.
				</div>
			</div>
		</Modal>
	);
};

export default LocationModal;
